import {
  Appeal,
  Evidence,
  Feedback,
  PowerOfAgency,
  Resolutions,
  User,
  Witness,
} from "types";
import apiClient from "../lib/apiClients";

// Witness
export const fetchWitness = async () => {
  const response = await apiClient.get<Witness[]>(
    "/complaint_entity/witnesses/"
  );
  return response.data;
};
export const addWitness = async (data: any) => {
  const response = await apiClient.post("/complaint_entity/witnesses/", data);
  return response.data;
};
export const editWitness = async (data: any) => {
  const response = await apiClient.put(
    "/complaint_entity/witnesses/" + data?.id + "/",
    data
  );
  return response.data;
};
export const deleteWitness = async (data: Witness) => {
  const response = await apiClient.delete(
    "/complaint_entity/witnesses/" + data?.id + "/"
  );
  return response.data;
};

// Evidence
export const fetchEvidence = async () => {
  const response = await apiClient.get<Evidence[]>(
    "/complaint_entity/evidences/"
  );
  return response.data;
};
export const addEvidence = async (data: any) => {
  const response = await apiClient.post("/complaint_entity/evidences/", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};
export const editEvidence = async (data: any) => {
  const response = await apiClient.put(
    "/complaint_entity/evidences/" + data?.id + "/",
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};
export const deleteEvidence = async (data: Evidence) => {
  const response = await apiClient.delete(
    "/complaint_entity/evidences/" + data?.id + "/"
  );
  return response.data;
};

// PowerOfAgency
export const fetcPowerOfAgency = async () => {
  const response = await apiClient.get<PowerOfAgency[]>(
    "/complaint_entity/power_of_agency/"
  );
  return response.data;
};
export const addPowerOfAgency = async (data: any) => {
  const response = await apiClient.post(
    "/complaint_entity/power_of_agency/",
    data
  );
  return response.data;
};
export const editPowerOfAgency = async (data: any) => {
  const response = await apiClient.put(
    "/complaint_entity/power_of_agency/" + data?.id + "/",
    data
  );
  return response.data;
};
export const deletePowerOfAgency = async (data: PowerOfAgency) => {
  const response = await apiClient.delete(
    "/complaint_entity/power_of_agency/" + data?.id + "/"
  );
  return response.data;
};

// Resolution
export const fetcResolution = async () => {
  const response = await apiClient.get<Resolutions[]>(
    "/complaint_entity/resolutions/"
  );
  return response.data;
};
export const addResolution = async (data: any) => {
  const response = await apiClient.post(
    "/complaint_entity/resolutions/",
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};
export const editResolution = async (data: any) => {
  const response = await apiClient.patch(
    "/complaint_entity/resolutions/" + data?.id + "/",
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};
export const editResolution2 = async (data: any) => {
  const response = await apiClient.patch(
    "/complaint_entity/resolutions/" + data?.id + "/",
    data
  );
  return response.data;
};
export const deleteResolution = async (data: Resolutions) => {
  const response = await apiClient.delete(
    "/complaint_entity/resolutions/" + data?.id + "/"
  );
  return response.data;
};

// Appeal
export const fetchAppeal = async () => {
  const response = await apiClient.get<Appeal[]>("/complaint_entity/appeals/");
  return response.data;
};
export const fetchAppealByOrgAndAdminUnit = async (
  admin_unit: string | number,
  org_unit: string | number,
  isRegistrar: boolean = false
) => {
  const url = isRegistrar
    ? `/complaint_entity/appeals/filter_by_unit/?admin_unit_id=${admin_unit}`
    : `/complaint_entity/appeals/filter_by_unit/?admin_unit_id=${admin_unit}&org_unit_id=${org_unit}`;
  const response = await apiClient.get<Appeal[]>(url);
  return response.data;
};
export const fetchAppealById = async (id: string) => {
  const response = await apiClient.get<Appeal>(
    `/complaint_entity/appeals/${id}/`
  );
  return response.data;
};
export const addAppeal = async (data: any) => {
  const response = await apiClient.post("/complaint_entity/appeals/", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};
export const editAppeal = async (data: any) => {
  const response = await apiClient.patch(
    "/complaint_entity/appeals/" + data?.id + "/",
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};
export const editAppeal2 = async (data: any) => {
  const response = await apiClient.patch(
    "/complaint_entity/appeals/" + data?.id + "/",
    data
  );
  return response.data;
};
export const deleteAppeal = async (data: Appeal) => {
  const response = await apiClient.delete(
    "/complaint_entity/appeals/" + data?.id + "/"
  );
  return response.data;
};

// Feedback
export const fetchFeedback = async (org_unit_id?: string, admin_unit_id?: string) => {
  let url = "/complaint_entity/feedbacks/";
  
  // If both org_unit_id and admin_unit_id are provided, use the filtered endpoint
  if (org_unit_id && admin_unit_id) {
    url = `/complaint_entity/feedbacks/by-org-and-admin-unit/?org_unit_id=${org_unit_id}&admin_unit_id=${admin_unit_id}`;
  }
  
  const response = await apiClient.get<Feedback[]>(url);
  return response.data;
};

// Users
export const fetchUsers = async () => {
  const response = await apiClient.get<User[]>("/account/auth/list_users/");
  return response.data;
};
export const suspendUser = async (userId: any) => {
  const response = await apiClient.patch(
    "/account/auth/" + userId + "/suspend_user/"
  );
  return response.data;
};
export const reactivateUser = async (userId: any) => {
  const response = await apiClient.patch(
    "/account/auth/" + userId + "/reactivate_user/"
  );
  return response.data;
};
export const deleteUser = async (userId: any) => {
  const response = await apiClient.delete(
    "/account/auth/" + userId + "/delete_user/"
  );
  return response.data;
};
